// extracted by mini-css-extract-plugin
export default {"customSelect":"custom-select_customSelect__bOuTN","selectorMobile":"custom-select_selectorMobile__YYg+X","mobWrapper":"custom-select_mobWrapper__HfA9l"};